import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'obpp-terms-and-condition',
  templateUrl: './obpp-terms-and-condition.html',
  styleUrls: ['./obpp-terms-and-condition.scss'],
})
export class ObppTermsConditionComponent implements OnInit {
  
  view: 'site' | 'service' = 'site';
  tncOfServiceEn = `${environment.tncOfServiceEn}`;
  tncOfServiceFr = `${environment.tncOfServiceFr}`;
  tncOfServiceSiteEn = `${environment.tncOfServiceSiteEn}`;
  tncOfServiceSiteFr = `${environment.tncOfServiceSiteFr}`;
  
  currentLang$: Observable<string>;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.currentLang$ = this.translate.onLangChange.pipe(
      map(event => event.lang),
      startWith(this.translate.currentLang || 'en')
    );
  }

  ngOnInit(): void {
    const viewFromRoute = this.route.snapshot.data['view'];
    this.view = viewFromRoute === 'service' ? 'service' : 'site';
  }
}